import * as React from 'react';

const AmexPaymentRebrandingSvg = (props: React.SVGProps<SVGSVGElement>) => (
    <svg viewBox="0 0 192 128" fill="none" {...props}>
        <g clipPath="url(#amex-payment-rebranding_svg__clip0_101_1049)">
            <path
                d="M0 16C0 7.163 7.163 0 16 0h160c8.837 0 16 7.163 16 16v96c0 8.837-7.163 16-16 16H16c-8.837 0-16-7.163-16-16V16z"
                fill="#006FCF"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M192.079 20.374h-17.217l-8.999 25.825-9.39-25.825h-17.608v40.21l-17.999-40.21H106.39l-18 41.084h12.521l3.522-8.216h18.781l3.522 8.216h23.476V32.894l10.565 28.564h9.781l10.565-28.564v28.564h10.956v6.26h-14.478L165.863 80.63l-12.129-12.912h-49.692v41.084h49.301l12.129-13.303 12.129 13.303h14.478v5.085h-17.217l-9.39-10.172-9.391 10.172h-58.3V66.935H79l23.477-52.822h22.693l8.217 17.999v-18h28.172l4.695 13.696 4.696-13.695h21.129v6.261zm0 56.343l-10.564 11.347 10.564 11.347v9.391l-19.173-20.738 19.173-20.346v8.999zm-53.214 32.085V99.02h-23.476v-6.26h23.085v-9.391h-23.085v-6.26h23.476v-9.391l19.564 20.346-19.564 20.738zm-30.911-64.56l5.479-13.304 5.477 13.303h-10.956z"
                fill="#fff"
            />
        </g>
        <defs>
            <clipPath id="amex-payment-rebranding_svg__clip0_101_1049">
                <path fill="#fff" d="M0 0h192v128H0z" />
            </clipPath>
        </defs>
    </svg>
);

AmexPaymentRebrandingSvg.displayName = 'AmexPaymentRebrandingSvg';
export default AmexPaymentRebrandingSvg;
